import { render } from "./NewspaperIcon.vue?vue&type=template&id=1bbbfb03"
import script from "./NewspaperIcon.vue?vue&type=script&lang=js"
export * from "./NewspaperIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__